// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"167":"56fec03d","177":"884a1ca6","423":"f79ca528"}[chunkId] + ".js";
};